import { deserializeResponse, serializeDTO, TypedRequestExecutor, type RefreshShipmentMethodsForBasket, type SearchForDropOffLocations, type UpdateShipmentMethod } from '@cloudsuite/cs-ordering-defs'
import { FAKE, REAL, registerDependency } from 'components/shared/dependency-injection/dependency-injection.js'
import { baseUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'
import { is } from 'typia'

export class OrderingError extends Error { }

const getRequestName = (request: object) => {
  if (is<RefreshShipmentMethodsForBasket>(request)) return 'RefreshShipmentMethodsForBasket'
  if (is<UpdateShipmentMethod>(request)) return 'UpdateShipmentMethod'
  if (is<SearchForDropOffLocations>(request)) return 'SearchForDropOffLocations'

  throw new Error(`Unexpected ordering request class "${request.constructor.name}"`)
}

type DeliveryMatchOrderingExecutor = { execute: TypedRequestExecutor }

const cleanup = (object: Record<string, any>) => {
  const obj = { ...object }

  Object.entries(obj).forEach(([key, v]) => {
    if (typeof v === 'symbol') delete obj[key]
    if (typeof v === 'object' && !Array.isArray(v)) obj[key] = cleanup(v)
  })

  return obj
}

export class FakeDeliveryMatchOrderingExecutor implements DeliveryMatchOrderingExecutor {
  public responses: { [commandName: string]: any } = {}
  public requests: { [commandName: string]: Record<string, any> }[] = []

  async execute(request: any): Promise<any> {
    const requestName = getRequestName(request)
    this.requests.push({ [requestName]: cleanup(request) })

    return this.responses[requestName]
  }
}

async function executeOrderingRequestUntyped(request: any): Promise<any> {
  const requestName = getRequestName(request)

  const url = new URL(`ordering/${requestName}/`, await baseUrl())
  const response = await fetch(
    url,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: serializeDTO(request),
    }
  )

  if (!response.ok) {
    throw new OrderingError()
  }

  return deserializeResponse(await response.json())
}

class RealDeliveryMatchOrderingExecutor implements DeliveryMatchOrderingExecutor {
  execute(request: any): Promise<any> {
    return executeOrderingRequestUntyped(request)
  }
}

export let deliveryMatchOrderingExecutor!: DeliveryMatchOrderingExecutor
registerDependency({
  [REAL]: () => deliveryMatchOrderingExecutor = new RealDeliveryMatchOrderingExecutor(),
  [FAKE]: () => deliveryMatchOrderingExecutor = new FakeDeliveryMatchOrderingExecutor(),
})
